module.exports = require("lodash/isPlainObject");


//////////////////
// WEBPACK FOOTER
// external "lodash/isPlainObject"
// module id = 19
// module chunks = 0